import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()

export class FormService {
	FORM_URI: string = environment.apiUrl + '/form';

	constructor(private httpClient: HttpClient) { }

	public getForm = (id) => {

		return this.httpClient.get(this.FORM_URI + `/${id}`);
	}

	public getFormsByCampaign = (id) => {
		return this.httpClient.get(this.FORM_URI + `/campaign/${id}`);
	}

	public create = (body) => {
		return this.httpClient.post(this.FORM_URI, body);
	}

	public update = (body, id) => {
		return this.httpClient.put(this.FORM_URI, body);
	}

	public delete = (id) => {
		return this.httpClient.delete(this.FORM_URI + `/${id}`);
	}

	public getSalesAssigned = (body) => {
		return this.httpClient.post(this.FORM_URI + `/sales-assigned`, body);
	}
}


// WEBPACK FOOTER //
// ./src/app/services/form.service.ts